import React from 'react';
import { Heart } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LikesCountProps {
  count: number | undefined | null;
  className?: string;
  variant?: 'light' | 'dark';
  isVotedByCurrentUser?: boolean;
}

const LikesCount: React.FC<LikesCountProps> = ({
  count = 0,
  className,
  variant = 'light',
  isVotedByCurrentUser = false
}) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-foreground';
  const bgColor = variant === 'light' ? 'bg-black/50' : 'bg-muted';

  return (
    <div
      className={cn('flex items-center gap-1 select-none pointer-events-none', className)}
      aria-hidden
    >
      <Heart
        className={cn(
          'w-5 h-5',
          isVotedByCurrentUser
            ? 'fill-red-500 text-red-500'
            : variant === 'light'
              ? 'fill-transparent text-white'
              : 'fill-transparent text-foreground'
        )}
      />
      <span className={cn('text-xs font-semibold px-1 rounded', textColor, bgColor)}>
        {count ?? 0}
      </span>
    </div>
  );
};

export default LikesCount;
